import React from 'react';

import useModal from 'Components-redesign/Modal/useModal';
import { useI18n } from 'Hooks';

import ForgotPasswordModal from './ForgotPasswordModal';
import { ForgotPasswordText } from './styles';

const ForgotPassword: React.FC = () => {
  const { t } = useI18n();

  const { isShowing, toggle, hide } = useModal();
  return (
    <>
      <ForgotPasswordText type="button" onClick={toggle}>
        {t('ResetPassword.ForgotYourPassword')}
      </ForgotPasswordText>
      <ForgotPasswordModal isShowing={isShowing} hide={hide} />
    </>
  );
};

export default ForgotPassword;
